define('models/StoreMessageCollection',['underscore','models/MessageCollection', 'models/StoreMessageModel', 'app'],

    function (_, MessageCollection, StoreMessageModel, app)
    {
        //
        // MessageCollection Store
        //

        var StoreMessageCollectionPrototype = {
            name: 'StoreMessageCollection',
            route: 'apiStoreMessageCollection',
            model:StoreMessageModel,
            privateApi:true,
            initialize:function(){
                MessageCollection.prototype.initialize.apply(this,arguments);
            },
            wsNewMessage:function(wsMessage){
                // ajoute / merge le message à la pile (add|update).
                // si le message indique être pour la boutique
                if(_.contains(wsMessage.data.stores,this.id_store)){
                    this.set([wsMessage.data],{remove: false});
                }else{
                    // sinon on supprime le message de la fiche boutique
                    this.remove([wsMessage.data]);
                }
            },
            fetchStore:function(options){
                _.extend(this,_.pick(options,['id_store']));
                this.fetch(options);
            },
            url:function(){
                return MessageCollection.prototype.url.apply(this,[_.pick(this,'id_store')]);
            }
        };

        var StoreMessageCollection = MessageCollection.extend(StoreMessageCollectionPrototype);

        return StoreMessageCollection;
    });

